import { render, staticRenderFns } from "./Dataset_celltype_grid.vue?vue&type=template&id=3e6813b6&scoped=true&"
import script from "./Dataset_celltype_grid.vue?vue&type=script&lang=js&"
export * from "./Dataset_celltype_grid.vue?vue&type=script&lang=js&"
import style0 from "./Dataset_celltype_grid.vue?vue&type=style&index=0&id=3e6813b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6813b6",
  null
  
)

export default component.exports